<template>
  <div>
    <a-layout>
      <a-layout-header>
        <a href="https://mi-asahi.co.jp/">
          <img src="../assets/logo.png">
        </a>

        <a-popover
          placement="bottomRight"
          trigger="click"
          :visible="isUserPopVisible"
          @visibleChange="onPopoverVisibleChanged"
        >
          <template slot="content">
            <a-button-group>
              <p>
                <a-button @click="onProfileClicked" style="width:100%">プロファイル</a-button>
              </p>
              <p>
                <a-button @click="onLogoutClicked" style="width:100%">ログアウト</a-button>
              </p>
            </a-button-group>
          </template>
          <a-tag color="red">
            <a-icon type="user" style="width:100%;height:100%"/>
          </a-tag>
        </a-popover>

        <a-divider></a-divider>
      </a-layout-header>
      <a-layout-content>
        <a-affix :offsetTop="this.winheight" style="max-height:0px">
          <a-button
            @click="onAffixClicked"
            shape="circle"
            icon="home"
            style="float:right;margin-right:20px"
          />
        </a-affix>
        <router-view/>
      </a-layout-content>
      <a-layout-footer>
        <a-divider/>
        <p>© 2016-{{ new Date().getFullYear() }} Mi-Asahi Co., Ltd.</p>
      </a-layout-footer>
    </a-layout>
    <!-- <a-drawer
      wrapClassName="css-drawer"
      placement="bottom"
      height="80px"
      :closable="false"
      @close="onClose"
      :visible="visible">
      <div style="margin:0 0;float:center;text-align:center;">
        <a-button-group>
          <a-button @click="onHomeClicked">Home</a-button>
          <a-button @click="onOperationClicked">Operation</a-button>
          <a-button @click="onProfileClicked">Profile</a-button>
        </a-button-group>
      </div>
    </a-drawer> -->
  </div>
</template>
  <!--  icon:info , clock-circle, home,form,edit -->
<script>
import AppPanel from "@/components/AppPanel.vue";
export default {
  name: "home",
  components: {
    AppPanel
  },
  data() {
    return {
      winheight: window.innerHeight - 50,
      isUserPopVisible: false,
      visible: false
    };
  },
  methods: {
    onAffixClicked() {
      console.log("HomeIcon Clicked.");
      
      // this.visible = true;
      this.$router.push({ path: "/" });
    },
    onClose() {
      this.visible = false;
    },
    onPopoverVisibleChanged(visible) {
      this.isUserPopVisible = visible;
    },
    onLogoutClicked() {
      this.isUserPopVisible = false;
      this.$store.dispatch("logout");
      this.$router.push({
        path: "/login"
      });
    },
    onHomeClicked() {
      this.visible = false;
      this.$router.push({ path: "/" });
    },
    onOperationClicked() {
      this.visible = false;
      this.$notification["info"]({
        message: "uncompleted"
      });
    },
    onProfileClicked() {
      this.visible = false;
      this.isUserPopVisible = false;
      this.$router.push({ path: "/info" });
    }
  }
};
</script>
<style scoped>
.css-drawer {
  padding: 0;
  margin: 0 0;
}

.ant-layout {
  background-color: #fff;
}

.ant-layout-header {
  padding: 0px;
  background-color: #fff;
}

.ant-layout-footer {
  padding: 0px;
  background-color: #fff;
}
.ant-layout-header img {
  float: left;
  height: 70%;
  margin-left: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.ant-layout-header .ant-tag {
  float: right;
  height: 50%;
  font-size: 30px;
  margin-top: 15px;
}

.ant-layout-header .ant-divider {
}

.ant-layout-content {
  padding: 5px;
}
</style>
